function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// @ts-nocheck
import { useEffect, useState } from 'react';
import { useRequest } from 'ahooks';
var useImportModal = function useImportModal(_ref) {
  var configuration = _ref.configuration,
    importType = _ref.importType,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? undefined : _ref$defaultValue,
    _ref$defaultImportFil = _ref.defaultImportFile,
    defaultImportFile = _ref$defaultImportFil === void 0 ? undefined : _ref$defaultImportFil;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    importer = _useState4[0],
    setImporter = _useState4[1];
  var _useState5 = useState(defaultImportFile),
    _useState6 = _slicedToArray(_useState5, 2),
    importFile = _useState6[0],
    setImportFile = _useState6[1];
  var getStatus = function getStatus(id) {
    var _configuration$client;
    if (!id) return new Promise(function (resolve, reject) {
      return resolve({});
    });
    return (_configuration$client = configuration.client) === null || _configuration$client === void 0 ? void 0 : _configuration$client.get("/".concat(configuration.rootUrl, "/imports/").concat(id));
  };
  var _useRequest = useRequest(getStatus, {
      pollingInterval: 3000,
      pollingWhenHidden: true,
      manual: true,
      onSuccess: function onSuccess(data) {
        if (data.id) setImportFile(data);
      }
    }),
    run = _useRequest.run,
    cancel = _useRequest.cancel;
  var onImport = function onImport(file) {
    var formData = new FormData();
    formData.append('file', file, file.name);
    if (configuration.client) {
      configuration.client.post("/".concat(configuration.rootUrl, "/imports/").concat(importType), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (data) {
        if (data.id) {
          run(data.id);
          setImportFile(data);
        }
        return false;
      });
    }
    return false;
  };
  useEffect(function () {
    if (configuration.client) {
      configuration.client.get("/".concat(configuration.rootUrl, "/importers/").concat(importType)).then(function (data) {
        setImporter(data);
      });
    }
  }, [importType]);
  useEffect(function () {
    if (['checked', 'imported'].includes(importFile === null || importFile === void 0 ? void 0 : importFile.state)) {
      cancel();
    }
  }, [importFile === null || importFile === void 0 ? void 0 : importFile.state]);
  var onReset = function onReset() {
    setImportFile(undefined);
    setLoading(false);
    cancel();
  };
  var onProcessImport = function onProcessImport() {
    if (configuration.client) {
      cancel();
      setImportFile(_objectSpread(_objectSpread({}, importFile), {}, {
        state: 'importing'
      }));
      configuration.client.put("/".concat(configuration.rootUrl, "/imports/").concat(importFile.id), {
        to_state: 'import'
      }).then(function (data) {
        if (data.id) {
          run(data.id);
          setImportFile(data);
        }
      });
    }
  };
  return {
    loading: loading,
    importer: importer,
    importFile: importFile,
    onImport: onImport,
    onProcessImport: onProcessImport,
    onReset: onReset
  };
};
export default useImportModal;